import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular-ivy';
import { defineCustomElements } from 'ionicons/dist/loader';
defineCustomElements(window);

loadSentry();

bootstrap().catch((e) =>
    Sentry.captureException(e, {
        extra: { message: 'Error during bootstrapping' },
    })
);

async function bootstrap() {
    if (environment.production) enableProdMode();

    await loadPeachCheckoutScript();

    await platformBrowserDynamic().bootstrapModule(AppModule);

    if ('serviceWorker' in navigator && environment.production)
        navigator.serviceWorker.register('ngsw-worker.js');
}

function loadSentry() {
    Sentry.init({
        dsn: 'https://d8adc115ba88f20c8026206af3e5404e@o4505918439686144.ingest.sentry.io/4505918525734912',
        integrations: [
            new Sentry.BrowserTracing({
                // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: ['localhost'],
                routingInstrumentation: Sentry.routingInstrumentation,
            }),
            new Sentry.Replay(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

function loadPeachCheckoutScript() {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;

        const isPointingToProd =
            environment.apiUrl.includes('apimdb.marideal.mu');

        script.src = `https://${
            isPointingToProd ? '' : 'sandbox-'
        }checkout.peachpayments.com/js/checkout.js`;

        document.head.appendChild(script);
    }).catch((e) =>
        Sentry.captureException(e, {
            extra: {
                message: 'Error during Peach Checkout script loading',
            },
        })
    );
}
